import React, { createContext, useContext, useState, useEffect } from 'react';

const ThemeContext = createContext();

export const ThemeProvider = ({ children }) => {
  const [theme, setTheme] = useState(() => {
    return localStorage.getItem('theme') || 'founder';
  });

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', theme);
    localStorage.setItem('theme', theme);
  }, [theme]);

  const toggleTheme = () => {
    setTheme((prev) => (prev === 'founder' ? 'vc' : 'founder'));
  };

  const isVCMode = theme === 'vc';
  const isFounderMode = theme === 'founder';

  return (
    <ThemeContext.Provider value={{ theme, toggleTheme, isVCMode, isFounderMode }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
};

/**
 * A handy component to easily swap text or components based on the active theme.
 * Usage: 
 *   <ThemeText 
 *     founder="Building things fast!" 
 *     vc="Delivering enterprise scalability & product-market fit" 
 *   />
 */
export const ThemeText = ({ founder, vc }) => {
  const { isVCMode } = useTheme();
  return <>{isVCMode ? vc : founder}</>;
};
